import { router } from 'expo-router'
import { View } from 'react-native'
import { StyleSheet } from 'react-native-unistyles'

import UserAvatar from '@/components/navigation/UserAvatar'
import UniTouchableRipple from '@/components/unistyles/UniTouchableRipple'
import { useAppStore } from '@/store/useAppStore'
import { triggerHapticClick } from '@/utils/haptics'
import buildOrgPath from '@/utils/orgRoute'
import trpc from '@/utils/trpc'

const UserAvatarButton = () => {
  const showOrganizationSwitcher = useAppStore.use.showOrganizationSwitcher()

  const handlePress = () => {
    router.push(buildOrgPath('/account'))
  }

  const handleLongPress = () => {
    triggerHapticClick()
    showOrganizationSwitcher()
  }

  const currentUser = trpc.user.current.useQuery({})

  if (!currentUser.data) {
    return null
  }

  return (
    <View testID="avatar-settings-button">
      <UniTouchableRipple
        accessibilityRole="button"
        borderless
        onLongPress={handleLongPress}
        onPress={handlePress}
        style={styles.root}
      >
        <UserAvatar
          size={30}
          user={{
            emailHash: currentUser.data.emailHash ?? undefined,
            firstName: currentUser.data.firstName,
            lastName: currentUser.data.lastName,
          }}
        />
      </UniTouchableRipple>
    </View>
  )
}

const styles = StyleSheet.create((theme) => {
  return {
    root: {
      borderRadius: 100,
      margin: theme.tokens.spacing[4],
    },
  }
})

export default UserAvatarButton
